export default __webpack_public_path__ + "static/media/cold-lead.ff50f080.png";